export function getValueFromComputedStyle(computedStyle: CSSStyleDeclaration, key: keyof CSSStyleDeclaration): number {
  return Math.round(parseFloat(computedStyle[key] as string) || 0);
}
